function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import Immutable from 'seamless-immutable';
import find from 'ramda/src/find';
import pathOr from 'ramda/src/pathOr';
import propEq from 'ramda/src/propEq';
import { createSelector } from 'reselect';
import { FeatureTogglesSelector } from 'invision-core/src/components/featureToggle/featureToggle.selectors';
import { BusinessUnitFetchFeatureToggleValuesSelector } from 'invision-core/src/components/configurable/configurable.selectors';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import i18n from 'invision-core/src/components/i18n/i18n';
import { MetadataCodeTypeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { getFilterService } from 'invision-core/src/components/injectables/injector.helper';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { PageSizePreferenceSelector, UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { DiscountsMetadataMapSelector } from 'invision-core/src/components/metadata/discounts/discounts.selectors';
import { CanUserPerformMiscellaneousAndItemAdjustmentSelector, SelectedCustomerSelector, CurrentCustomerAccountingMethodSelector, CurrentCustomerIsExternallyManagedARSelector, CurrentCustomerSelector } from './customer.selectors';
import { ADJUSTMENT_REASON_TYPE_CODE, ADJUSTMENT_TYPE_TYPE_CODE } from '../constants/billing.payments.constants';
import { DISPUTE_INVOICE, ONE_TIME_MAKE_PAYMENT, PAYMENT_ADJUSTMENT_ACCESS } from '../../security.attributes';
import { createInvoiceItemsTableViewModel } from '../selectors/billing.payments.invoice.selectors.helper';
import { createTableViewModel as createTableBillingViewModel, formatOpenInvoicesList } from '../selectors/customer.billing.selectors.helper';
import LocaleKeys from '../../locales/keys';
import { AR_TRANSFER_ADJUSTMENT_EXTERNAL_REFERENCE, DEPOSIT_TRANSFER, DEPOSIT_UPDATED, MISC_ADJUSTMENT, WRITEOFF_ADJUSTMENT, WRITEOFF_REVERSAL_ADJUSTMENT } from '../../components/adjustment/adjustment.modal.constants';
import { INVOICE, WITHHELD_TAX_EXTERNAL_REF } from '../../components/billingPayments/applyTaxCertificate/applyTaxCertificate.modal.constants';
import { EMPTY_ARRAY } from 'invision-core/src/constants/common.constants';
import { MAKE_PAYMENT_TYPES } from '../../components/customer/makePayment/make.payment.constants';
import { CONVERT_TO_CREDIT } from '../../components/billingPayments/billing.payments.constants';

/* ALERT! The associated RetrieveConvergentBillerAccountSummary call should not be used - use RetrieveConvergentBillerSubscriberSummary instead */

export var IsFetchingBillingPaymentsSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.billingPayments.isFetchingBillingPayments;
});
export var CurrentInvoiceIdSelector = function CurrentInvoiceIdSelector(state) {
  return state.router.currentParams.invoiceId;
};
export var AdjustmentReasonsCodeSelector = function AdjustmentReasonsCodeSelector(state) {
  return state.metadata.codes[ADJUSTMENT_REASON_TYPE_CODE];
};
export var AdjustmentTypeCodeSelector = function AdjustmentTypeCodeSelector(state) {
  return state.metadata.codes[ADJUSTMENT_TYPE_TYPE_CODE];
};
var EMPTY_ADJUSTMENTS = [];
export var AdjustmentsSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  var adjustments = selectedCustomer.billingPayments.data.adjustments;
  return adjustments ? adjustments : EMPTY_ADJUSTMENTS;
});
var EMPTY_PAYMENTS = [];
export var PaymentsSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  var payments = selectedCustomer.billingPayments.data.payments;
  return payments ? payments : EMPTY_PAYMENTS;
});
export var CreditNotesSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  var creditNotes = selectedCustomer.billingPayments.data.creditNotes;
  return creditNotes ? creditNotes : EMPTY_ARRAY;
});
export var DebitNotesSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  var debitNotes = selectedCustomer.billingPayments.data.debitNotes;
  return debitNotes ? debitNotes : EMPTY_ARRAY;
});
export var CreditNotesToPaymentMappingSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  var creditToPaymentMapping = selectedCustomer.billingPayments.data.creditToPaymentMapping;
  return creditToPaymentMapping ? creditToPaymentMapping : EMPTY_ARRAY;
});
var EMPTY_INVOICE_SUMMARIES = [];
export var InvoiceSummariesSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  var invoiceSummaries = selectedCustomer.billingPayments.data.invoiceSummaries;
  return invoiceSummaries ? invoiceSummaries : EMPTY_INVOICE_SUMMARIES;
});
export var StartDateSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.billingPayments.metadata.startDate;
});
export var EndDateSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.billingPayments.metadata.endDate;
});
export var DateShortcutSelector = createSelector(SelectedCustomerSelector, function (selectedCustomer) {
  return selectedCustomer.billingPayments.metadata.dateShortcut;
});
export var TypeSelector = createSelector(SelectedCustomerSelector, function (selectedCustomer) {
  return selectedCustomer.billingPayments.metadata.typeFilter;
});
var EMPTY_INVOICE_ITEMS = [];
export var InvoiceItemsByIdSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  var invoiceDetails = selectedCustomer.billingPayments.invoiceDetails;
  return invoiceDetails && invoiceDetails.InvoiceItems || EMPTY_INVOICE_ITEMS;
});
var EMPTY_ITEMS_TABLE = [];
var EMPTY_INVOICE = {};
export var InvoiceSummaryByIdSelector = createSelector([InvoiceSummariesSelector, CurrentInvoiceIdSelector], function (invoiceSummaries, currentInvoiceId) {
  return invoiceSummaries && currentInvoiceId ? find(propEq(currentInvoiceId.toString(), 'InvoiceId'))(invoiceSummaries) : EMPTY_INVOICE;
});
export var InvoiceItemsTableDataSelector = createSelector([IsFetchingBillingPaymentsSelector, InvoiceItemsByIdSelector, MetadataCodeTypeSelector(CODES.InvoiceItemType), CurrentCustomerIsExternallyManagedARSelector, UserSecurityAttributesSelector, CanUserPerformMiscellaneousAndItemAdjustmentSelector, DiscountsMetadataMapSelector, InvoiceSummaryByIdSelector, IsDbss, CurrentCustomerSelector, FeatureTogglesSelector, BusinessUnitFetchFeatureToggleValuesSelector], function (isFetchingBillingPayments, invoiceItems, invoiceItemTypes, currentCustomerIsExternallyManagedAR, userSecurityAttributes, canUserPerformMiscellaneousAndItemAdjustment, discountsMetadataMap, invoiceSummary, isDbss, currentCustomer, features, buFeatureToggles) {
  var canApplyAdjustment = canUserPerformMiscellaneousAndItemAdjustment && (!currentCustomerIsExternallyManagedAR || currentCustomerIsExternallyManagedAR && hasAccess(userSecurityAttributes, PAYMENT_ADJUSTMENT_ACCESS));
  var witheldTaxesApplicable = invoiceSummary && ((invoiceSummary === null || invoiceSummary === void 0 ? void 0 : invoiceSummary.TotalWithheldTax) > 0 || (invoiceSummary === null || invoiceSummary === void 0 ? void 0 : invoiceSummary.TotalCashReceivable) > 0) && isDbss;
  return !isFetchingBillingPayments ? createInvoiceItemsTableViewModel(invoiceItems, invoiceSummary, invoiceItemTypes, canApplyAdjustment, discountsMetadataMap, userSecurityAttributes, witheldTaxesApplicable, currentCustomer, features, buFeatureToggles) : EMPTY_ITEMS_TABLE;
});
var getBillingDataEntries = function getBillingDataEntries(adjustments, invoiceSummaries, payments, creditNotes, debitNotes) {
  return Immutable.asMutable(creditNotes.concat(debitNotes).concat(adjustments).concat(invoiceSummaries)).concat(payments).sort(function (a, b) {
    return new Date(b.Date || b.IssueDate) - new Date(a.Date || a.IssueDate);
  });
};
export var CombinedBillingDataSelector = createSelector([IsFetchingBillingPaymentsSelector, AdjustmentsSelector, InvoiceSummariesSelector, PaymentsSelector, CreditNotesSelector, DebitNotesSelector], function (isFetchingBillingPayments, adjustments, invoiceSummaries, payments, creditNotes, debitNotes) {
  return !isFetchingBillingPayments ? getBillingDataEntries(adjustments, invoiceSummaries, payments, creditNotes, debitNotes) : [];
});
var defaultCurrency = 'USD';
export var CombinedBillingCurrencyCodeSelector = createSelector([CombinedBillingDataSelector], function () {
  var combinedBilling = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var currObj = combinedBilling.find(function (x) {
    return x.CurrencyCode;
  });
  return currObj ? currObj.CurrencyCode : defaultCurrency;
});
var EMPTY_TABLE_DATA = [];
export var TableDataSelector = createSelector([CombinedBillingDataSelector, AdjustmentTypeCodeSelector, AdjustmentReasonsCodeSelector, MetadataCodeTypeSelector(CODES.PaymentInstrumentType), MetadataCodeTypeSelector(CODES.PointOfSalePaymentType), CreditNotesToPaymentMappingSelector, CurrentCustomerAccountingMethodSelector], function (views, adjustmentTypes, reasons, paymentInstrumentTypes, posPaymentTypes, creditToPaymentMapping, currentCustomerAccountingMethod) {
  return paymentInstrumentTypes ? createTableBillingViewModel(views, adjustmentTypes, reasons, paymentInstrumentTypes, posPaymentTypes, creditToPaymentMapping, currentCustomerAccountingMethod) : EMPTY_TABLE_DATA;
});
export var AdjustmentTypeValueOptions = createSelector([AdjustmentTypeCodeSelector], function (codes) {
  return codes ? [{
    Value: null,
    Name: i18n.translate(LocaleKeys.ADJUSTMENTS.SELECT_ADJUSTMENT_TYPE)
  }].concat(codes.items.map(function (code) {
    return {
      Name: code.Name,
      Value: code.Value
    };
  }).asMutable({
    deep: true
  })) : [];
});
export var AdjustmentReasonCodeValueOptions = createSelector([AdjustmentReasonsCodeSelector, CurrentCustomerIsExternallyManagedARSelector], function (codes, customerIsExternallyManaged) {
  var items = codes ? codes.items : [];
  var reasonCodes = items.filter(function (code) {
    var flag = true;
    if (!customerIsExternallyManaged) {
      flag = code.AdditionalProperties.find(propEq('external_reference', 'Key')).Value !== AR_TRANSFER_ADJUSTMENT_EXTERNAL_REFERENCE;
    }
    if (flag) {
      flag = code.Value !== WRITEOFF_ADJUSTMENT && code.Value !== WRITEOFF_REVERSAL_ADJUSTMENT;
    }
    var isDepositTransferOrDepositUpdated = code.Value === DEPOSIT_TRANSFER || code.Value === DEPOSIT_UPDATED;
    return flag && !isDepositTransferOrDepositUpdated;
  });
  return reasonCodes.length ? [{
    Value: null,
    Name: i18n.translate(LocaleKeys.ADJUSTMENTS.SELECT_REASON_CODE)
  }].concat(reasonCodes.map(function (code) {
    var reasonCode = {
      Name: code.Name,
      Value: code.Value
    };
    code.AdditionalProperties.forEach(function (additionalProperty) {
      reasonCode[additionalProperty.Key] = additionalProperty.Value;
    });
    return reasonCode;
  }).asMutable({
    deep: true
  })) : [];
});
export var AdjustmentReasonCodeForTaxSelectionOptions = createSelector([AdjustmentReasonsCodeSelector], function (codes) {
  var items = codes ? codes.items : [];
  var reasonCodes = items.find(function (code) {
    var selectedCode = code.AdditionalProperties.find(function (additionalProperty) {
      return additionalProperty.Key === WITHHELD_TAX_EXTERNAL_REF.Key && additionalProperty.Value === WITHHELD_TAX_EXTERNAL_REF.Value;
    });
    if (selectedCode) {
      return true;
    }
  });
  if (reasonCodes) {
    return [{
      Name: reasonCodes.Name,
      Value: reasonCodes.Value
    }];
  }
  return [];
});
export var IsFetchingInvoiceContentSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.billingPaymentsInvoiceContent.isFetchingInvoiceContent;
});
export var PageNumberSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.billingPayments.metadata.pageNumber;
});
export var SelectedPageSizePreference = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.billingPayments.metadata.pageSize;
});
export var RecordCountSelector = createSelector([CombinedBillingDataSelector], function (combinedBilling) {
  return combinedBilling.length;
});
export var PageCountSelector = createSelector([RecordCountSelector, SelectedPageSizePreference], function (recordCount, pageSize) {
  return Math.ceil(recordCount / pageSize);
});
export var PageSizeSelector = createSelector([PageSizePreferenceSelector], function (pageSize) {
  return pageSize;
});
export var StartRecordSelector = createSelector([PageNumberSelector, SelectedPageSizePreference], function (pageNumber, pageSize) {
  return (pageNumber - 1) * pageSize + 1;
});
export var EndRecordSelector = createSelector([RecordCountSelector, PageNumberSelector, SelectedPageSizePreference], function (recordCount, pageNumber, pageSize) {
  var endNumber = pageNumber * pageSize;
  if (endNumber < recordCount) {
    return endNumber;
  }
  return recordCount;
});
export var BillingLedgerTableDataSelector = createSelector([TableDataSelector], function (tableData) {
  return {
    data: tableData.data,
    columnDefs: tableData.columnDefs
  };
});
export var InvoiceDetailsSummarySelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.billingPayments.invoiceDetails && selectedCustomer.billingPayments.invoiceDetails.InvoiceSummary;
});
export var IsFetchingInvoiceDetailsSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.billingPayments.isFetchingInvoiceDetails;
});
export var InvoiceDetailsPageCountSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.billingPayments.invoiceDetails.PageCount;
});
export var InvoiceDetailsRecordCountSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.billingPayments.invoiceDetails.RecordCount;
});
var EMPTY_INVOICE_LIST = [];
export var InvoiceListSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr(EMPTY_INVOICE_LIST, ['billingPayments', 'invoiceList'], selectedCustomer);
});
export var IsFetchingInvoiceListSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.billingPayments.isFetchingInvoiceList;
});
export var InvoiceFilterSelector = createImmutableSelector(SelectedCustomerSelector, function (selectedCustomer) {
  return selectedCustomer.billingPayments.metadata.invoiceFilter;
});
export var InvoiceListForDropDownSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr(EMPTY_INVOICE_LIST, ['billingPayments', 'invoiceListDropdown'], selectedCustomer);
});
export var InvoiceListWithTaxForDropDownSelector = createImmutableSelector([InvoiceListForDropDownSelector], function (InvoiceList) {
  var $filter = getFilterService();
  var formattedInvoiceList = [];
  InvoiceList === null || InvoiceList === void 0 ? void 0 : InvoiceList.map(function (invoiceItem) {
    var _invoiceItem$Invoice;
    if (((_invoiceItem$Invoice = invoiceItem.Invoice) === null || _invoiceItem$Invoice === void 0 ? void 0 : _invoiceItem$Invoice.WithheldTaxDue) > 0) {
      return invoiceItem;
    }
  }).forEach(function (item) {
    if (item !== null && item !== void 0 && item.Invoice.WithheldTaxDue && (item === null || item === void 0 ? void 0 : item.Invoice.WithheldTaxDue) > 0) {
      formattedInvoiceList.push({
        amount: item.Invoice.CurrentDue,
        id: item.Invoice.InvoiceId,
        text: "".concat(i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.INVOICE_PREFIX)).concat(item.Invoice.InvoiceNumber, " - ").concat($filter('invCurrency')(item.Invoice.CurrentDue, item.Invoice.CurrencyCode)),
        type: INVOICE,
        taxDueAmount: item.Invoice.WithheldTaxDue
      });
    }
  });
  return formattedInvoiceList;
});
export var AdjustmentConfigSelector = createImmutableSelector(MetadataCodeTypeSelector(CODES.AdjustmentConfig), function (adjustmentConfig) {
  var adjustmentConfigObject = adjustmentConfig.find(function (item) {
    return !item.Global;
  }) || adjustmentConfig.find(function (item) {
    return item.Global;
  });
  var resultsMap = {};
  if (adjustmentConfigObject) {
    adjustmentConfigObject.AdditionalProperties.forEach(function (config) {
      resultsMap[config.Key] = config.Value;
    });
  }
  return resultsMap;
});
export var BillingPaymentsSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.billingPayments;
});
export var BillingPaymentsOpenInvoicesSelector = createImmutableSelector([BillingPaymentsSelector], function (billingPayments) {
  return billingPayments.openInvoices;
});
export var TotalAccountBalanceSelector = createImmutableSelector([BillingPaymentsSelector], function (billingPayments) {
  return billingPayments.totalAccountBalance;
});
export var TotalCashReceivableSelector = createImmutableSelector([BillingPaymentsSelector], function (billingPayments) {
  return billingPayments.totalCashReceivable;
});
export var TotalWithheldTaxSelector = createImmutableSelector([BillingPaymentsSelector], function (billingPayments) {
  return billingPayments.totalWithheldTax;
});
export var PageCountOfLedgerSelector = createImmutableSelector([BillingPaymentsSelector], function (billingPayments) {
  return billingPayments.pageCount;
});
export var RecordCountOfLedgerSelector = createImmutableSelector([BillingPaymentsSelector], function (billingPayments) {
  return billingPayments.recordCount;
});
export var PageSizeOfLedgerSelector = createImmutableSelector([BillingPaymentsSelector], function (billingPayments) {
  return billingPayments.metadata.pageSize;
});
export var HierarchyInvoiceNodeSubscriberIdSelector = createImmutableSelector([BillingPaymentsSelector], function (billingPayments) {
  return billingPayments.hierarchyInvoiceNodeSubscriberId;
});
export var OpenInvoicesListMetadataSelector = createImmutableSelector([BillingPaymentsOpenInvoicesSelector], function (billingPaymentsOpenInvoices) {
  return billingPaymentsOpenInvoices.metadata;
});
export var OpenInvoicesListSelector = createImmutableSelector([BillingPaymentsOpenInvoicesSelector], function (billingPaymentsOpenInvoices) {
  return formatOpenInvoicesList(billingPaymentsOpenInvoices.invoices);
});
export var OpenInvoicesPageCountSelector = createImmutableSelector([BillingPaymentsOpenInvoicesSelector], function (billingPaymentsOpenInvoices) {
  return billingPaymentsOpenInvoices.pageCount;
});
export var OpenInvoicesRecordCountSelector = createImmutableSelector([BillingPaymentsOpenInvoicesSelector], function (billingPaymentsOpenInvoices) {
  return billingPaymentsOpenInvoices.recordCount;
});
export var OpenInvoicesCurrentPageSelector = createImmutableSelector([OpenInvoicesListMetadataSelector], function (openInvoicesListMetadata) {
  return openInvoicesListMetadata.pageNumber;
});
export var OpenInvoicesPageSizeSelector = createImmutableSelector([OpenInvoicesListMetadataSelector], function (openInvoicesListMetadata) {
  return openInvoicesListMetadata.pageSize;
});
export var IsFetchingOpenInvoicesSelector = createImmutableSelector([BillingPaymentsOpenInvoicesSelector], function (billingPaymentsOpenInvoices) {
  return billingPaymentsOpenInvoices.isFetchingOpenInvoices;
});
export var IsApplyingCreditNoteSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer ? selectedCustomer.isApplyingCreditNote : false;
});
export var IsFetchingAdjustmentDetailsSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer ? selectedCustomer.billingPayments.isFetchingAdjustmentDetails : false;
});
export var AdjustmentOrCreditNoteDetailsSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer ? selectedCustomer.billingPayments.adjustmentOrCreditNoteDetails : EMPTY_ARRAY;
});
export var AdjustmentItemsTableDataSelector = createImmutableSelector([AdjustmentOrCreditNoteDetailsSelector], function (adjustmentDetails) {
  var $filter = getFilterService();
  var currencyCode = adjustmentDetails && adjustmentDetails.AdjustmentSummary && adjustmentDetails.AdjustmentSummary.CurrencyCode;
  return adjustmentDetails && adjustmentDetails.AdjustmentDetails.length ? adjustmentDetails.AdjustmentDetails.map(function (adjustment) {
    return {
      amount: adjustment.AppliedAmount,
      balance: adjustment.Balance,
      currencyCode: currencyCode,
      date: $filter('localShortDate')(adjustment.AppliedDate) || null,
      debitNoteAdjustmentNumber: adjustment.DebitNoteAdjustmentNumber,
      invoiceNumber: adjustment.InvoiceNumber,
      paymentReceiptNumber: adjustment.PaymentReceiptNumber
    };
  }) : EMPTY_ARRAY;
});
export var OpenInvoicesStartDateSelector = createImmutableSelector([OpenInvoicesListMetadataSelector], function (openInvoicesListMetadata) {
  return openInvoicesListMetadata.startDate;
});
export var OpenInvoicesEndDateSelector = createImmutableSelector([OpenInvoicesListMetadataSelector], function (openInvoicesListMetadata) {
  return openInvoicesListMetadata.endDate;
});
export var OpenInvoicesDateShortcutSelector = createImmutableSelector([OpenInvoicesListMetadataSelector], function (openInvoicesListMetadata) {
  return openInvoicesListMetadata.dateShortcut;
});
export var OpenInvoicesSearchTermSelector = createImmutableSelector([OpenInvoicesListMetadataSelector], function (openInvoicesListMetadata) {
  return openInvoicesListMetadata.invoiceSearchTerm;
});
export var BillingLedgerCurrentTabSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.billingPayments.currentTab;
});
var getInvoiceActionItem = function getInvoiceActionItem(invoiceItem, userSecurityAttributes, isCreditType) {
  var invoiceActions = [];
  if (isCreditType) {
    invoiceActions.push({
      id: invoiceItem.Invoice.InvoiceId,
      actionId: CONVERT_TO_CREDIT,
      label: i18n.translate(LocaleKeys.CONVERT_TO_CREDIT)
    });
    return invoiceActions;
  }
  if (hasAccess(userSecurityAttributes, ONE_TIME_MAKE_PAYMENT)) {
    invoiceActions.push({
      id: invoiceItem.Invoice.InvoiceId,
      actionId: MAKE_PAYMENT_TYPES.INVOICE,
      label: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.MAKE_A_PAYMENT)
    });
  }
  if (hasAccess(userSecurityAttributes, PAYMENT_ADJUSTMENT_ACCESS)) {
    invoiceActions.push({
      id: invoiceItem.Invoice.InvoiceId,
      actionId: MISC_ADJUSTMENT,
      label: i18n.translate(LocaleKeys.CUSTOMER_DASHBOARD.MISC_ADJUSTMENT)
    });
  }
  if (hasAccess(userSecurityAttributes, DISPUTE_INVOICE)) {
    invoiceActions.push({
      id: invoiceItem.Invoice.InvoiceNumber,
      actionId: LocaleKeys.DISPUTE_INVOICE,
      label: i18n.translate(LocaleKeys.DISPUTE_INVOICE)
    });
  }
  return invoiceActions;
};
export var InvoiceListForOpenInvoiceWidgetSelector = createImmutableSelector([BillingPaymentsOpenInvoicesSelector, UserSecurityAttributesSelector], function (invoiceList, userSecurityAttributes) {
  var openInvoiceWidgetData = [];
  var balanceLabel = i18n.translate(LocaleKeys.CUSTOMER_DASHBOARD.BALANCE);
  var chargeLabel = i18n.translate(LocaleKeys.CUSTOMER_DASHBOARD.CHARGE);
  var dueDateLabel = i18n.translate(LocaleKeys.CUSTOMER_DASHBOARD.DUE_DATE);
  var accountBalanceLabel = i18n.translate(LocaleKeys.CUSTOMER_DASHBOARD.ACCOUNT_BALANCE_FROM_LAST_INVOICE);
  var accountBalanceToolTipLabel = i18n.translate(LocaleKeys.CUSTOMER_DASHBOARD.ACCOUNT_BALANCE_TOOLTIP_LABEL);
  invoiceList.invoices.forEach(function (invoiceItem) {
    var isCreditType = invoiceItem.Invoice.CurrentDue < 0;
    openInvoiceWidgetData.push({
      actions: getInvoiceActionItem(invoiceItem, userSecurityAttributes, isCreditType),
      link: {
        label: invoiceItem.Invoice.InvoiceNumber,
        id: invoiceItem.Invoice.InvoiceId
      },
      values: [{
        label: balanceLabel,
        value: getFilterService()('invCurrency')(invoiceItem.Invoice.CurrentDue, invoiceItem.Invoice.CurrencyCode)
      }, {
        label: chargeLabel,
        value: getFilterService()('invCurrency')(invoiceItem.Invoice.Balance, invoiceItem.Invoice.CurrencyCode)
      }, {
        label: dueDateLabel,
        value: getFilterService()('date')(invoiceItem.Invoice.DueDate, 'shortDate')
      }].concat(_toConsumableArray(invoiceItem.Invoice.PreviousInvoiceBalance && invoiceItem.Invoice.PreviousInvoiceBalance !== 0 ? [{
        label: accountBalanceLabel,
        tooltipText: accountBalanceToolTipLabel,
        value: invoiceItem.Invoice.PreviousInvoiceBalance ? getFilterService()('invCurrency')(invoiceItem.Invoice.PreviousInvoiceBalance, invoiceItem.Invoice.CurrencyCode) : getFilterService()('invCurrency')(0, invoiceItem.Invoice.CurrencyCode)
      }] : []))
    });
  });
  return openInvoiceWidgetData;
});